/**
 * Gorgias chat cosmetic tweaks, injected into the chat widget.
 *
 * The widget content lives inside the `#chat-window` iframe. That iframe uses
 * `srcdoc`, so it is SAME-ORIGIN with the page — theme CSS can't cross the
 * iframe boundary, but JS may inject a <style> into the iframe's document.
 * Gorgias confirmed (HIG-51) this content is on us to style, so we do it here.
 *
 * Tweaks:
 *  1. HIG-51: remove Chrome's default focus outline drawn around the chat root
 *     container on open. Scoped to `:focus` only, so real form fields inside the
 *     chat keep their keyboard-focus ring (accessibility).
 *  2. "Wechseln zu Whatsapp" banner: hide the dismiss (X) button — there is no
 *     reason to dismiss it — and vertically centre the text, which Gorgias lays
 *     out top-aligned (flex-start) so it sat too high. Both rules are scoped to
 *     the banner that actually contains the wa.me link, so other Gorgias
 *     disclaimers are untouched.
 */
(function () {
  var STYLE_ID = 'hp-gorgias-focus-fix';
  var CSS = [
    '[class*="message-window-iframe"]:focus{outline:none !important}',
    'div:has(a[href*="api.whatsapp.com"]) button[aria-label="Dismiss privacy policy disclaimer"]{display:none !important}',
    'div:has(> span a[href*="api.whatsapp.com"]){align-items:center !important}'
  ].join('');

  function inject(iframe) {
    if (!iframe || iframe.id !== 'chat-window') return;
    try {
      var doc = iframe.contentDocument;
      if (!doc || !doc.head || doc.getElementById(STYLE_ID)) return;
      var style = doc.createElement('style');
      style.id = STYLE_ID;
      style.textContent = CSS;
      doc.head.appendChild(style);
    } catch (e) {
      /* iframe not ready or unexpectedly cross-origin — ignore */
    }
  }

  // Primary hook: fires every time the chat-window iframe (re)loads, even when
  // Gorgias creates it long after page load. Capture phase because `load`
  // doesn't bubble.
  document.addEventListener('load', function (evt) { inject(evt.target); }, true);

  // Fallback: the Gorgias bundle may have mounted the iframe before this ran.
  // A few delayed scans cover the async init without a permanent poll.
  [0, 1000, 2500, 5000].forEach(function (delay) {
    setTimeout(function () { inject(document.getElementById('chat-window')); }, delay);
  });
})();
